import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';

import { AlertService } from '../alert';
import { PackagingService } from '../services/packaging.service';

@Component({
  selector: 'app-packaging',
  providers: [PackagingService, AlertService],
  templateUrl: './packaging.component.html',
  styleUrls: ['./packaging.component.css']
})
export class PackagingComponent implements OnInit {

    loading = false;
    packagings: any[] = [];
    packaging: any = null;
    packagingsFiltered: any[] = [];
  
    constructor(
      private router: Router,
      private packagingService: PackagingService, 
      private alertService: AlertService) { }
  
    ngOnInit() {
      this.load();
    }
  
    async load(): Promise<void> {
      this.loading = true;
      await this.getPackagings();
      this.loading = false;
    }
  
    doesMatch(element: any, filter) {
      return ((element != null && element.toLowerCase().indexOf(filter.toLowerCase())) >= 0);
    }
  
    doFilter(filterValue) {
      this.packagingsFiltered = [];
      this.packagings.forEach(packaging => {
        if (this.doesMatch(packaging.name, filterValue)) {
          this.packagingsFiltered.push(packaging);
        }
      });
    }
  
    async getPackagings(): Promise<void> {
      this.loading = true;
      try {
      this.packagings = await this.packagingService.getPackagings().toPromise();
    } catch (error) {
      // no packagings found
    } finally {
      this.doFilter('');
      this.loading = false;
    }
      
    }
  
    addPackaging() {
        this.router.navigate(['/packaging', 'new']);
    }  

    deletePackaging(name: string) {
        this.packagingService.deletePackaging(name)
        .subscribe(
            data => {
                this.load();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/packaging/packaging.component.ts